<!-- 左侧导航 -->
<template>
  <ul class="zlr-menu">
    <li v-for="(item,index) in menuList"
        :key="index">
      <!-- <router-link :to="item.path">{{item.title}}</router-link> -->
      <a :class="[!item.name?'zlr-menu-disabled':'',$route.matched.some(({name}) => item.name===name)?'active':'']"
         @click="linkHandle(item.name)">{{item.title}}</a>
      <template v-if="item.children">
        <ul class="zlr-menu-child">
          <li v-for="(child,childIndex) in item.children"
              :key="childIndex">
            <a :class="[!child.name?'zlr-menu-disabled':'',$route.matched.some(({name}) => child.name===name)?'active':'']"
               @click="linkHandle(child.name)">{{child.title}}</a>
          </li>
        </ul>
      </template>
    </li>
  </ul>
</template>

<script>
// less
import './menu.less'
export default {
  name: '',
  props: {
    menuList: {
      type: [Array],
      default: () => {
        return []
      }
    }
  },
  components: {},
  data () {
    return {
    }
  },
  computed: {},
  mounted () {
  },
  methods: {
    linkHandle (name) {
      this.$router.push({
        name
      })
    }
  }
}
</script>
<style lang='less' scoped>
</style>
